import * as React from 'react';
type Props = {
  className?: string;
};
export function MagnifyingGlassFilled({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-magnifying-glass-filled"
      className={className}
    >
      <path
        d="M15.7386 13.7206L14.9535 13.1012L14.9533 13.1015L15.7386 13.7206ZM7.11747 14.7384L7.73689 13.9534L7.73671 13.9532L7.11747 14.7384ZM18.2567 20.669C18.6262 21.0795 19.2585 21.1128 19.669 20.7433C20.0795 20.3738 20.1128 19.7415 19.7433 19.331L18.2567 20.669ZM14.1015 5.88465C16.3303 7.64255 16.7114 10.8733 14.9535 13.1012L16.5237 14.34C18.9658 11.2449 18.4362 6.75633 15.3401 4.31431L14.1015 5.88465ZM14.9533 13.1015C13.1965 15.33 9.96487 15.7113 7.73689 13.9534L6.49805 15.5235C9.59308 17.9655 14.0828 17.4362 16.5239 14.3397L14.9533 13.1015ZM7.73671 13.9532C5.50886 12.1962 5.12697 8.9645 6.88472 6.73671L5.3146 5.49787C2.87244 8.59309 3.40306 13.0826 6.49823 15.5236L7.73671 13.9532ZM6.88472 6.73671C8.64273 4.50859 11.8727 4.12677 14.1015 5.88465L15.3401 4.31431C12.2439 1.87227 7.75651 2.40297 5.3146 5.49787L6.88472 6.73671ZM13.7567 15.669L18.2567 20.669L19.7433 19.331L15.2433 14.331L13.7567 15.669Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8578 7.64471C14.1589 8.67093 14.3814 10.5571 13.3551 11.8578C12.3294 13.1589 10.4427 13.3814 9.1421 12.3551C7.84145 11.3294 7.61849 9.44274 8.64471 8.1421C9.67093 6.84145 11.5566 6.61849 12.8578 7.64471Z"
        fill="currentColor"
      />
    </svg>
  );
}
